export default __webpack_public_path__ + "3ed9f71c1b133c714551678aaf0e89c5.png";